import React, { memo, useContext, useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import Barcode from 'react-barcode';
import { fetchPostData } from '@/Components/hooks/Api';
import { toastifyError } from '@/Components/Common/AlertMsg';
import { getShowingDateText } from '@/Components/Common/Utility';
import { AgencyContext } from 'Context/Agency';


const BarCode = (props) => {

    const { agencyID, propID, masPropID, codeNo, printStatus, setPrintStatus, isVehicle = false, propIDs = null, codeNos = null } = props;

    const isMulti = propIDs && Array.isArray(propIDs) && propIDs.length > 0;
    const propIDsKey = isMulti ? propIDs.map(String).join(',') : '';
    const { datezone, setChangesStatus, BarCodeStatus, setBarCodeStatus, agencyData } = useContext(AgencyContext);

    const useQuery = () => {
        const params = new URLSearchParams(useLocation().search);
        return {
            get: (param) => params.get(param)
        };
    };

    const query = useQuery();
    let MstVehicle = query?.get('page');
    const isMaster = MstVehicle != '' && MstVehicle === 'MST-Name-Dash' || MstVehicle === 'MST-Property-Dash' || MstVehicle === 'MST-Vehicle-Dash' ? true : false;


    const [barCodeData, setBarCodeData] = useState([])

    const componentRef = useRef();

    const printForm = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Data',
        onAfterPrint: () => { '' }
    })

    useEffect(() => {
        if (isMulti && agencyID && propIDs?.length > 0) {
            let cancelled = false;
            const fetchAll = async () => {
                const promises = propIDs.map((pid) => get_BarCode_Data(agencyID, pid, null));
                const results = await Promise.all(promises);
                if (cancelled) return;
                const valid = results.filter(Boolean);
                setBarCodeData(valid);
                setBarCodeStatus(valid.length > 0 ? valid : []);
            };
            fetchAll();
            return () => { cancelled = true; };
        } else if (!isMulti && agencyID && (propID || masPropID)) {
            get_BarCode_Data(agencyID, propID, masPropID).then((res) => {
                // Same shape as multi: barCodeData is an array of Table arrays so map sees barData[0].Property
                if (res && Array.isArray(res) && res.length > 0) {
                    const wrapped = [res];
                    setBarCodeStatus(wrapped);
                    setBarCodeData(wrapped);
                } else {
                    setBarCodeData([]);
                    setBarCodeStatus([]);
                }
            });
        } else if (isMulti && !propIDsKey) {
            setBarCodeData([]);
            setBarCodeStatus([]);
        }
        // propIDsKey is a stable string so effect runs only when IDs actually change, not on every render
    }, [agencyID, propID, masPropID, isMulti, propIDsKey])

    const get_BarCode_Data = async (agencyID, propID, masPropID) => {
        const val = { 'AgencyID': agencyID, 'PropertyID': propID || 0, 'MasterPropertyID': masPropID || 0 }
        const val1 = { 'AgencyID': agencyID, 'PropertyID': 0, 'MasterPropertyID': masPropID || 0 }
        const res = await fetchPostData("PropertyBarCode/GetData_PropertyBarCode", isMaster ? val1 : val);
        return res || null;
    }

    useEffect(() => {
        const canPrintSingle = printStatus && !isMulti && barCodeData?.length > 0;
        const canPrintMulti = printStatus && isMulti && barCodeData?.length === propIDs?.length && barCodeData?.length > 0;
        if (canPrintSingle || canPrintMulti) {
            printForm();
            setPrintStatus(false);
        } else if (printStatus) {
            if (isMulti && (!propIDs?.length || barCodeData?.length !== propIDs?.length)) {
                toastifyError("No Data Available");
            } else if (!isMulti && barCodeData?.length === 0) {
                toastifyError("No Data Available");
            }
            setPrintStatus(false);
        }
    }, [printStatus, isMulti, propIDs, barCodeData?.length])

    const hasPrintContent = barCodeData?.length > 0;
    const totalLabels = hasPrintContent ? barCodeData.reduce((acc, barData) => acc + (barData?.Property?.length > 0 ? barData.Property.length : 1), 0) : 0;
    let labelIndex = 0;

    return (

        (printStatus || hasPrintContent) &&
        <div style={{ position: 'absolute', left: '-9999px', top: 0, zIndex: -1 }} aria-hidden="true">
            <div ref={componentRef} style={{ width: '100%', padding: '20px', backgroundColor: 'white', visibility: 'visible' }}>
                <style>{`
                    @media print {
                        @page {
                            size: 3in 4in;
                            margin: 0;
                        }
                        .barcode-label-page { page-break-after: always; }
                        .barcode-label-page:last-child { page-break-after: auto; }
                    }
                `}</style>
                <div>
                    {barCodeData?.length > 0 &&
                        barCodeData?.map((barData, barIndex) => {
                            const items = barData?.[0]?.Property?.length > 0 ? barData?.[0]?.Property : (barData ? [barData?.[0]] : []);
                            return items.map((proData, propIndex) => {
                                labelIndex += 1;
                                const isLastLabel = labelIndex === totalLabels;
                                const incidentNumber = proData?.IncidentNumber || proData?.IncidentNumber || '';
                                const reportedDate = proData?.ReportedDate ? getShowingDateText(proData?.ReportedDate) : ''; const dateValue = barData?.ReportedDtTm || proData?.ReportedDtTm ? getShowingDateText(barData?.ReportedDtTm || proData?.ReportedDtTm) : '08/08/2024 24:36';
                                const codeForLabel = isMulti ? (codeNos?.[barIndex] ?? proData?.PropertyNumber) : codeNo;
                                const prnCode = codeForLabel || `PRN-${String(proData?.PropertyID || 210).padStart(6, '0')}`;

                                return (
                                    <div
                                        key={`${barIndex}-${propIndex}`}
                                        style={{
                                            width: '3in',
                                            minHeight: '4in',
                                            height: '4in',
                                            border: '2px solid black',
                                            padding: '10px',
                                            marginBottom: '20px',
                                            backgroundColor: 'white',
                                            boxSizing: 'border-box',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            fontSize: '10px',
                                            fontFamily: 'Arial, sans-serif',
                                            pageBreakInside: 'avoid',
                                            pageBreakAfter: isLastLabel ? 'auto' : 'always'
                                        }}
                                        className={isLastLabel ? '' : 'barcode-label-page'}
                                    >
                                        {/* Header Section */}
                                        <div style={{ marginBottom: '8px', borderBottom: '1px solid black', paddingBottom: '8px' }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '6px' }}>
                                                {/* Logo */}
                                                <div style={{
                                                    width: '45px',
                                                    height: '45px',
                                                    border: '2px solid black',
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    marginRight: '8px',
                                                    flexShrink: 0,
                                                    backgroundColor: 'white',
                                                    overflow: 'hidden'
                                                }}>
                                                    {barData?.[0]?.Agency_Photo ? (
                                                        <img
                                                            src={barData?.[0]?.Agency_Photo}
                                                            alt="Agency Logo"
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'cover',
                                                                borderRadius: '50%'
                                                            }}
                                                        />
                                                    ) : (
                                                        <svg width="38" height="38" viewBox="0 0 38 38" style={{ overflow: 'visible' }}>
                                                            <circle cx="19" cy="19" r="17" fill="white" stroke="black" strokeWidth="1.5" />
                                                            {/* Shield */}
                                                            <path d="M 19 8 L 12 10 L 12 16 Q 12 22 19 28 Q 26 22 26 16 L 26 10 Z" fill="white" stroke="black" strokeWidth="0.8" />
                                                            {/* Simple eagle representation */}
                                                            <circle cx="19" cy="16" r="3" fill="black" />
                                                            <path d="M 16 14 L 19 12 L 22 14" stroke="black" strokeWidth="0.8" fill="none" />
                                                            <path d="M 16 18 L 19 20 L 22 18" stroke="black" strokeWidth="0.8" fill="none" />
                                                            {/* Text around */}
                                                            <text x="19" y="32" textAnchor="middle" fontSize="5" fontWeight="bold">DOJ</text>
                                                        </svg>
                                                    )}
                                                </div>
                                                {/* Agency Info */}
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '4px' }}>
                                                        {barData?.[0]?.Agency_Name || ''}
                                                    </div>
                                                    <div style={{ fontSize: '8px', marginBottom: '2px' }}>
                                                        Address: {barData?.[0]?.Agency_Address1 || ''}
                                                    </div>
                                                    <div style={{ fontSize: '8px', display: 'flex', gap: '12px' }}>
                                                        <span>Phone: {barData?.[0]?.Agency_Phone || ''}</span>
                                                        <span>Fax: {barData?.[0]?.Agency_Fax || ''}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Incident Details Section */}
                                        <div style={{ marginBottom: '8px', border: '1px solid black', padding: '0 6px' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '9px' }}>
                                                <colgroup>
                                                    <col style={{ width: '50%' }} />
                                                    <col style={{ width: '50%' }} />
                                                </colgroup>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ borderRight: '1px solid black', padding: '4px 6px', verticalAlign: 'top' }}>
                                                            <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>Incident #:</div>
                                                            <div>{incidentNumber}</div>
                                                        </td>
                                                        <td style={{ padding: '4px 6px', verticalAlign: 'top' }}>
                                                            <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>Reported:</div>
                                                            <div>{reportedDate}</div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Barcode Section */}
                                        <div style={{ marginBottom: '8px', textAlign: 'center', borderBottom: '1px solid black', paddingBottom: '6px' }}>
                                            <div style={{ fontSize: '10px', fontWeight: 'bold', marginBottom: '4px' }}>
                                                {prnCode}
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                {(codeForLabel || prnCode) && (
                                                    <Barcode
                                                        value={codeForLabel || prnCode}
                                                        format="CODE128"
                                                        width={1.5}
                                                        height={30}
                                                        displayValue={false}
                                                    />
                                                )}
                                            </div>
                                        </div>

                                        {/* Item Details Section */}
                                        <div style={{ flex: 1, border: '1px solid black', marginBottom: '8px' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '9px' }}>
                                                <colgroup>
                                                    <col style={{ width: '16.67%' }} />
                                                    <col style={{ width: '16.67%' }} />
                                                    <col style={{ width: '16.67%' }} />
                                                    <col style={{ width: '16.67%' }} />
                                                    <col style={{ width: '16.67%' }} />
                                                    <col style={{ width: '16.67%' }} />
                                                </colgroup>
                                                <tbody>
                                                    {/* Row 1: Classification and Category */}
                                                    <tr>
                                                        <td colSpan="3" style={{ borderBottom: '1px solid black', padding: '4px 6px', borderRight: '1px solid black', verticalAlign: 'top' }}>
                                                            <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>Classification:</div>
                                                            <div>{proData?.PropertyClassification_Description || ''}</div>
                                                        </td>
                                                        <td colSpan="3" style={{ borderBottom: '1px solid black', padding: '4px 6px', verticalAlign: 'top' }}>
                                                            <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>Category:</div>
                                                            <div>{proData?.PropertyCategory_Description || ''}</div>
                                                        </td>
                                                    </tr>
                                                    {/* Row 2: Brand and Loss Code */}
                                                    <tr>
                                                        <td colSpan="3" style={{ borderBottom: '1px solid black', padding: '4px 6px', borderRight: '1px solid black', verticalAlign: 'top' }}>
                                                            <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>{isVehicle ? "Plate Type:" : "Brand:"}</div>
                                                            <div>{isVehicle ? proData?.PropertyVehiclePlateType_Description || '' : proData?.Brand || ''}</div>
                                                        </td>
                                                        <td colSpan="3" style={{ borderBottom: '1px solid black', padding: '4px 6px', verticalAlign: 'top' }}>
                                                            <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>{isVehicle ? "Plate State & No:" : "Loss Code:"}</div>
                                                            <div>{isVehicle ? proData?.PropertyVehicleState_Description : proData?.PropertyLossCode_Description || ''}</div>
                                                        </td>
                                                    </tr>
                                                    {/* Row 3: Serial Id, Model ID, and Quantity */}
                                                    <tr>
                                                        <td colSpan="2" style={{ borderBottom: '1px solid black', padding: '4px 6px', borderRight: '1px solid black', verticalAlign: 'top' }}>
                                                            <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>{isVehicle ? "VIN:" : "Serial ID:"}</div>
                                                            <div>{isVehicle ? proData?.VIN || "" : proData?.SerialID || ''}</div>
                                                        </td>
                                                        <td colSpan="2" style={{ borderBottom: '1px solid black', padding: '4px 6px', borderRight: '1px solid black', verticalAlign: 'top' }}>
                                                            <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>{isVehicle ? "Loss Code:" : "Model ID:"}</div>
                                                            <div>{isVehicle ? proData?.PropertyLossCode_Description || '' : proData?.ModelID || ''}</div>
                                                        </td>
                                                        <td colSpan="2" style={{ borderBottom: '1px solid black', padding: '4px 6px', verticalAlign: 'top' }}>
                                                            <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>{isVehicle ? "Value:" : "Quantity:"}</div>
                                                            <div>{isVehicle ? proData?.Value || "" : proData?.Quantity || ""}</div>
                                                        </td>
                                                    </tr>
                                                    {/* Row 4: Storage Location */}
                                                    <tr>
                                                        <td colSpan="6" style={{ padding: '4px 6px', verticalAlign: 'top' }}>
                                                            <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>Storage Location:</div>
                                                            <div>{proData?.PropertyLocation_Description || ''}</div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Instruction Section */}
                                        <div style={{ textAlign: 'center', fontSize: '8px', color: '#333', paddingTop: '4px' }}>
                                            Scan barcode to view current storage location in Property System
                                        </div>
                                    </div>
                                );
                            });
                        })}
                </div>
            </div>
        </div>

    )
}

export default memo(BarCode)
